import { StudentLoginPage } from "./page"

export default StudentLoginPage
